<app-layout>
    <mat-toolbar class="page-header" role="heading">
        <h1>{{ 'PendingTimeOffReport' | translate: {Default: "Pending Time Off Report"} }}</h1>
    </mat-toolbar>

    <div class="content">
        <app-pending-time-off-details-data-grid></app-pending-time-off-details-data-grid>
    </div>
</app-layout> 